import React, { useEffect, useState, useRef } from 'react';
import { Link, useNavigate } from 'react-router-dom';
//axios
import useAxiosHook from 'src/webapp/hooks/comn/axios.hook';
//fontAwesome
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
//observer
import { useInView } from 'react-intersection-observer';
//styles
import styles from 'src/asset/scss/style/market.module.scss';
//Store
import usePartnerStore from 'src/webapp/stores/partner.store';
//comp-wrapper
import Section from 'src/webapp/views/wrapper/Section';
import FixedPanel from 'src/webapp/views/wrapper/FixedPanel';
import FlickPanel from 'src/webapp/views/wrapper/FlickPanel';
//comp
import Element from 'src/webapp/views/wrapper/Element';//공통엘리먼트
import Menu from 'src/webapp/views/component/Menu';//메뉴
import TitleBar from 'src/webapp/views/component/title/TitleBar';//상단타이틀
import Spinner from 'src/webapp/views/component/loading/Spinner';//inview로딩
import SearchArea from './SearchArea';//검색영역
import Market from './Market';//마켓상품
import EmptyData from 'src/webapp/views/component/EmptyData';//데이터없음

export default function MarketList() {
    const { axiosPostHandler } = useAxiosHook();//axios
    const navigator = useNavigate();//navigator
    const { isState, partner } = usePartnerStore();

    /* =============== 내가작성한글보기 =============== */
    const [ isPartner,setIsPartner ] = useState(false);
    /* =============== 내가작성한글보기 =============== */
    /* =============== 거래완료안보기 =============== */
    const [ status,setStatus ] = useState(false);
    /* =============== 거래완료안보기 =============== */
    /* =============== 검색어입력(제목) =============== */
    const [ searchWord,setSearchWord ] = useState('');
    /* =============== 검색어입력(제목) =============== */
    
    /* =============== 마켓상품호출 =============== */
    const isLock = useRef(false);
    const pageRef = useRef(20);
    const [ marketList, setMarketList ] = useState([]);
    const marketItemListAPI = async(type) => {
        if(isLock.current) { return; }

        isLock.current = true;
        const DATA = { RANGE:1, STATUS:(!status ? 0 : 3), PARTNER_CD:isPartner ? partner.COMN_CD : 0, SUBJECT:searchWord.replaceAll(' ', ''), ROWNUM:(type == 0 ? 20 : pageRef.current)}
        const result = await axiosPostHandler(`marketItemListForJson.do`, DATA);
        setTimeout(function() { isLock.current = false; }, 300);
        if(!result || result.message !== "SUCCESS") { 
            if(type === 0) { setMarketList([]); }
            pageRef.current = null; 
            return; 
        }
        if(result.message === "SUCCESS") {
            setMarketList(type === 0 ? result.data : marketList.concat(result.data));
            pageRef.current = result.data.length < 20 ? null : pageRef.current + 20;
        }
    }
    useEffect(() => {
        if(!isState) { return; }
        
        pageRef.current = 20;
        marketItemListAPI(0);
    }, [isState, status, isPartner, searchWord]);
    /* =============== 마켓상품호출 =============== */
    /* =============== 매출리스트 무한로딩호출 =============== */
    const [ inViewRef, inView] = useInView({ threshold: .5 });
    useEffect(() => {
        if(!inView && (marketList.length <= 0 || pageRef.current === null)) { return; }
        
        marketItemListAPI(1);
    }, [inView]);
    /* =============== 매출리스트 무한로딩호출 =============== */

    return (
        <>
        <Section className={"section sectionContainer"}>
            <Menu />
            <Element tag={`div`} className={`container`}>
                <FixedPanel>
                    <TitleBar title={`라이더 마켓`} />
                    <SearchArea marketList={marketList} setSearchWord={setSearchWord} status={status} setStatus={setStatus} isPartner={isPartner} setIsPartner={setIsPartner} />
                </FixedPanel>
                <FlickPanel>
                    {marketList.length > 0 ?
                        <Element tag={`ul`} className={[styles.marketContainer, marketList.length < 9 ? styles.rowItem : null].join(' ')}>
                            {marketList.map((item, idx) =>
                                <Element tag={`li`} anyprop={(e) => navigator(`/market/detail/${item.SEQ_NO}`, {state:item})} key={idx}>
                                    <Market data={item} />
                                </Element>
                            )}
                        </Element>
                    : <Element tag={`div`} className={styles.emptyData}><EmptyData content={`매출내역은`}  /></Element>}
                    {pageRef.current !== null && marketList.length > 0 ? <Element tag={`div`} propRef={inViewRef}><Spinner inView={true} /></Element> : null}
                </FlickPanel>
            </Element>
        </Section>
        <Element tag={`div`} className={styles.fixedButtonArea}><Link to={`/market/reg`}><FontAwesomeIcon icon="fa-solid fa-plus" /><Element tag={`span`}>글쓰기</Element></Link></Element>
        </>
    );
}